














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import { IDocType } from "@/@types/admin/guest/user";
import identity_cards from "@/config/identity/identity_cards";
import { isValidBirthCertificate } from "@/services/user/personal_data";

@Component({
  mixins: [validationMixin],
  validations: {
    doc: {
      required: requiredIf(function (this: any) {
        return this.required;
      }),
      maxLength: maxLength(12),
    },
  },
})
export default class Document4 extends Vue {
  @Prop({ type: String, default: "" }) document!: string;
  @Prop({ type: String, default: "" }) type!: string;
  @Prop({ type: Boolean, default: true }) required!: boolean;

  doc = "";

  serial = true;

  get doctype(): IDocType | null {
    const type = identity_cards.find((el) => el._id == this.type);
    return type ? type : null;
  }

  @Watch("doc")
  processingDoc(): void {
    this.doc = this.doc.replace(/\s+/g, "");

    if (!this.required && !this.doc) {
      this.serial = true;
      this.$emit("number", this.doc);
      return;
    }

    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    if (!isValidBirthCertificate(this.doc)) {
      this.serial = false;
      return;
    } else this.serial = true;

    this.$emit("number", this.doc);
  }

  @Watch("document")
  createDoc(): void {
    if (!this.document) return;
    this.doc = this.document;
  }

  mounted(): void {
    this.createDoc();
  }
}
